export const MANDATAIRE_MESURE_IMPORT_TEMPLATE =
  "/docs/Template_import_mesures.xlsx";
export const MANDATAIRE_MESURE_IMPORT_MANUAL =
  "/docs/Notice_d_utilisation_de_l_import.pdf";
